import React, {useEffect, useRef, useState} from "react";
import {useHistory, useParams} from "react-router-dom";
import {useFormik} from "formik";
import * as yup from "yup";
import Utils from "../../libraries/utils";
import micro_reporter_api from "../../apis/micro-reporter-api";
import kafein_logo from "../../assets/img/kafein-logo-white.png";
import logo from "../../assets/img/logo192.png";
import {Alert, Button, Col, Form} from "react-bootstrap";
import {Toast} from "primereact/toast";

const ChangePassword = () => {

    const {id} = useParams();
    const [success,setSuccess]=useState(false);
    const toast=useRef(null);
const history=useHistory();
    useEffect(() => {
    }, []);


    const isActive = (lld) => {
        const diffTime = Math.abs(Date.now() - lld);
        return diffTime > 21600000 ? false : true;
    }

    const accountAutoLogin = () => {
        let user = JSON.parse(localStorage.getItem("user"));
        if (user && isActive(user.lld)) {
            window.location.href = "/dashboard";
        }
    };
    accountAutoLogin();

    const formik = useFormik({
        initialValues: {
            password: "",
            repeatPassword: "",
            code: id
        },
        validationSchema: yup.object({
            password: yup.string().required('Password can not be blank.')
                .min(8, "Password must contains min 8 Characters, One Uppercase, One Lowercase, One Number and One Special Character.")
                .matches(/([A-Z])/, "Password must contains One Uppercase.")
                .matches(/([a-z])/, "Password must contains One Lowercase.")
                .matches(/([0-9])/, "Password must contains One Number.")
                .matches(/([ !"#$%&'()*+,-./:;<=>?@\\^_`{|}~])/, "Password must contains One Special Character."),
            repeatPassword: yup.string().required('Password can not be blank.')
                .min(8, "Password must contains min 8 Characters, One Uppercase, One Lowercase, One Number and One Special Character.")
                .matches(/([A-Z])/, "Password must contains One Uppercase.")
                .matches(/([a-z])/, "Password must contains One Lowercase.")
                .matches(/([0-9])/, "Password must contains One Number.")
                .matches(/([ !"#$%&'()*+,-./:;<=>?@\\^_`{|}~])/, "Password must contains One Special Character."),        }),
        onSubmit: values => {
            resetPassword(values);
        },
    });

    const resetPassword = (values) => {
        (async () => {
            let response;
            if(values?.password!==values.repeatPassword)
            {
                toast?.current?.show({
                    severity: 'error',
                    detail: 'Passwords not equal.'
                });
                
                return;
            }
            try {
                Utils.loadingScreen("show");
                let headers = {"username": values.username, "relatedName": encodeURIComponent(values.username)};
                const config = {headers};
                 response = await micro_reporter_api.post('/micro-reporter/authentication/reset/password', values, config);
                response.data["lld"] = Date.now();
                localStorage.setItem('user', JSON.stringify(response.data));
                window.location.href = "/dashboard";
                Utils.loadingScreen("hide");
            } catch (err) {
                Utils.loadingScreen("hide");

            }
            if (response !== undefined && response?.status === 200) {
                toast?.current?.show({
                    severity: 'success',
                    detail: 'Transaction is succesfully.'
                });
                setSuccess(true)
                setTimeout(() => {
                    history.push("")
                }, 1500);
            } else{
                toast?.current?.show({
                    severity: 'error',
                    detail: 'You have changed your password in advance. Use the "Forgot password" link from the login screen to change again!'
                });
            }
        })();
    };



    return (
        <div>
            <Toast ref={toast}/>
            <div className="container">
                <div id="login-form-panel">
                    <div style={{
                        backgroundColor: "#33344a",
                        height: "60px",
                        width: "100%",
                        marginBottom: "20px",
                        padding: "10px 20px"
                    }}>
                        <img
                            src={kafein_logo}
                            width="120"
                            height="35"
                            alt="Kafein"
                            style={{display: "block", marginLeft: "auto", marginRight: "auto", float: "left"}}
                        />
                        <div style={{
                            marginTop: "5px",
                            display: "block",
                            marginLeft: "auto",
                            marginRight: "auto",
                            width: "max-content"
                        }}>
                            <img
                                src={logo}
                                width="30"
                                height="30"
                                className="d-inline-block align-top"
                                alt="Micro Reporter"
                                style={{marginRight: "7px", marginTop: "-2px"}}
                            />
                            <span style={{fontFamily: "Lexend Deca", color: "#ffffff"}}>Micro Reporter</span>
                        </div>
                    </div>
                    <div id="login-center-div">

                        <Form noValidate onSubmit={formik.handleSubmit} id="login-form">
                            <Form.Row>
                                <Form.Group as={Col} md="12" controlId="validationFormik01">
                                    <Form.Label>New Password</Form.Label>
                                    <Form.Control
                                        type="password"
                                        name="password"
                                        placeholder=""
                                        onChange={formik.handleChange}
                                        value={formik.values.password}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.password && formik.errors.password ? (
                                        <div style={{
                                            fontFamily: "Lexend Deca",
                                            fontSize: "12px",
                                            color: "#ff0000"
                                        }}>{formik.errors.password}</div>
                                    ) : null}
                                </Form.Group>
                            </Form.Row>
                            <Form.Row>
                                <Form.Group as={Col} md="12" controlId="validationFormik02">
                                    <Form.Label>New Password Again</Form.Label>
                                    <Form.Control
                                        type="password"
                                        name="repeatPassword"
                                        onChange={formik.handleChange}
                                        value={formik.values.repeatPassword}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.repeatPassword && formik.errors.repeatPassword ? (
                                        <div style={{
                                            fontFamily: "Lexend Deca",
                                            fontSize: "12px",
                                            color: "#ff0000"
                                        }}>{formik.errors.repeatPassword}</div>
                                    ) : null}

                                    {formik.values.password !== formik.values.repeatPassword ? (

                                        <div style={{
                                            fontFamily: "Lexend Deca",
                                            fontSize: "12px",
                                            color: "#ff0000"
                                        }}>Passwords not equal.</div>
                                    ) : null}
                                </Form.Group>
                            </Form.Row>
                            <Button type="submit"  disabled={success} block>Reset Password</Button>




                        </Form>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default ChangePassword;
